import { render, staticRenderFns } from "./PstAudits.vue?vue&type=template&id=5c7fa0b6&scoped=true&"
import script from "./PstAudits.vue?vue&type=script&lang=js&"
export * from "./PstAudits.vue?vue&type=script&lang=js&"
import style0 from "./PstAudits.vue?vue&type=style&index=0&id=5c7fa0b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7fa0b6",
  null
  
)

export default component.exports